import { useSelector } from 'src/store/react';
import { selectResults } from 'src/store/selectors';

export const useSearchParams = () => {
  const results = useSelector(selectResults);
  return results?.searchParams || {};
};
